<template>
    <div>
        <div>
            <div class="alert alert-success" v-if="form.schedule_delete_message && form.schedule_delete_success">
                {{form.schedule_delete_message}}
            </div>
            <table class="table">
                <thead class="thead-light">
                <tr>
                    <th class="text-dark" scope="col">Report Name</th>
                    <th class="text-dark" scope="col">Subject</th>
                    <th class="text-dark" scope="col">Frequency</th>
                    <th class="text-dark" scope="col">Time</th>
                    <th class="text-dark" scope="col">Day</th>
                    <th class="text-dark" scope="col">Delete</th>
                </tr>
                </thead>
                <tbody>
                <tr  v-for="item in reports" :key="item.id">
                    <td>{{item.report_name}}</td>
                    <td>{{item.subject}}</td>
                    <td>{{item.delivery_frequency}}</td>
                    <td>{{changeTime(item.scheduled_time)}}</td>
                    <td>{{item.scheduled_day}}</td>
                    <td align="center">
                        <button @click.prevent="editScheduleReport(item)"><i class="fa fa-pencil"></i> </button>
                        <button @click.prevent="deleteReport(item.id)"><i class="fa fa-trash"></i> </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div id="scheduleReportEdit" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">
                <!-- Modal content-->
                <div class="modal-content schedule-modal">
                    <div class="modal-body text-dark">
                        <h4 class="text-center mb-2">{{scheduleReportForm.report_name}}
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </h4>
                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm" for="email_subject">Email Subject <span class="text-danger">*</span></label>
                            <input type="text" class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control" v-model="scheduleReportForm.subject" name="email_subject" id="email_subject" placeholder="Enter email subject"/>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.subject">{{ scheduleReportErrors.subject }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm">Recipients <span class="text-danger">*</span></label>
                            <multiselect v-model="scheduleReportForm.recipients"
                                         id="recipientEmailSelected"
                                         tag-placeholder="Press enter to add"
                                         placeholder="Add an email"
                                         :options="options"
                                         :multiple="true"
                                         track-by="email"
                                         label="email"
                                         :taggable="true"
                                         :close-on-select="false"
                                         @tag="addRecipient">
                                <template v-slot:noOptions>
                                    <span style="display:none"> List is empty. </span>
                                </template>
                            </multiselect>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.recipients">{{ scheduleReportErrors.recipients }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm"
                                   for="delivery_frequency">Delivery Frequency <span class="text-danger">*</span></label>
                            <select name="delivery_frequency" id="delivery_frequency" v-model="scheduleReportForm.delivery_frequency"
                                    class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control" required @change="frequencyChanged($event)" >
                                <option selected disabled>Select frequency</option>
                                <option value="Daily">Daily</option>
                                <option value="Weekly">Weekly</option>
                                <option value="Monthly">Monthly</option>
                            </select>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.delivery_frequency">{{ scheduleReportErrors.delivery_frequency }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm mb-0"
                                   for="scheduled_time">Scheduled Time <span class="text-danger">*</span></label>
                            <p><small>Data is captured up to 2 hours before the email is sent. This is to make sure this email is delivered as on-time as possible.</small></p>
                            <datetime type="time" name="scheduled_time" format="hh:mm a" use12-hour :minute-step="15" required v-model="scheduleReportForm.scheduled_time" id="scheduled_time" class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control"></datetime>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.scheduled_time">{{ scheduleReportErrors.scheduled_time }}</span>
                        </div>

                        <div class="form-group mb-2">
                            <label class="text-grey-darkest text-sm"
                                   for="scheduled_day">Delivery Day <span class="text-danger">*</span></label>
                            <select name="scheduled_day" id="scheduled_day" v-model="scheduleReportForm.scheduled_day"
                                    class="p-1 border-1 focus:outline-none text-grey-darkest text-sm form-control" :disabled="scheduleReportForm.scheduled_day_disabled">
                                <option selected disabled>Select date</option>
                                <option value="monday">Monday</option>
                                <option value="tuesday">Tuesday</option>
                                <option value="wednesday">Wednesday</option>
                                <option value="thursday">Thursday</option>
                                <option value="friday">Friday</option>
                                <option value="saturday">Saturday</option>
                                <option value="sunday">Sunday</option>
                            </select>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.scheduled_day">{{ scheduleReportErrors.scheduled_day }}</span>
                        </div>

                        <div class="form-group mb-2" v-if="scheduleReportForm.report_format_disabled">
                            <label class="text-grey-darkest text-sm"
                                   for="report_format">Format <span class="text-danger">*</span></label>
                            <select name="report_format" id="report_format" v-model="scheduleReportForm.report_format"
                                    class="p-1 bg-white border-1 focus:outline-none text-grey-darkest text-sm form-control">
                                <option selected disabled>Select report format</option>
                                <option value="pdf">PDF</option>
                                <option value="excel">Excel</option>
                            </select>
                            <span class="text-danger text-sm" v-if="scheduleReportErrors.report_format">{{ scheduleReportErrors.report_format }}</span>
                        </div>


                        <div class="text-center mt-4">
                            <button class="btn btn-primary rounded-full" @click="scheduleReport">
                                Update
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../utils/form";
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";
export default {
    name: "schedule-reports",
    components: {Multiselect},
    props: ['user', 'teams','reports'],

    data() {
        return {
            form: $.extend(true, new SparkForm({
                schedule_delete_message : '',
                schedule_delete_success: false
            }), Spark.forms.exchangeSettings),
            zone_time:false,
            minutes:null,
            options                         : [],
            scheduleReportForm : new Form({
                id: '',
                subject: '',
                recipients:[],
                delivery_frequency: '',
                scheduled_time: '',
                scheduled_day: '',
                report_id: '',
                report_name: '',
                report_format: '',
                scheduled_day_disabled : false,
                report_format_disabled : false,
            }),
            scheduleReportHasError: false,
            scheduleReportErrors: {
                subject:'',
                recipients:'',
                delivery_frequency:'',
                scheduled_time:'',
                scheduled_day:'',
                report_format:'',
            },
            reports_exports: [
                { id: 'bid-list', name: "Bid List", excel: true, pdf: true },
                { id: 'bid-proposal', name: "Bid Proposal Report", excel: true, pdf: true },
                { id: 'captured-contracts', name: "Won Contracts", excel: true, pdf: true },
                { id: 'client-sales-history', name: "Client Sales History", excel: true, pdf: true },
                { id: 'client-profile-summary-report', name: "Client Profile Summary Report", excel: true, pdf: true },
                { id: 'dead-recap', name: "Dead Recap", excel: true, pdf: true},
                { id: 'gross-margin-captured-projects', name: "Gross Margin Captured Projects", excel: true, pdf: true },
                { id: 'sales-meeting-overview', name: "Sales Meeting Overview", excel: true, pdf: true },
                { id: 'sales-status-activity-summary', name: "Pipeline Activity Summary", excel: true, pdf: true},
                { id: 'status-activity/normal', name: "Pipeline Activity", excel: true, pdf: true},
                { id: 'status-activity/comments', name: "Pipeline Activity - With Comments", excel: true, pdf: true},
                { id: 'status-activity-pipeline-Estimator', name: "Pipeline Activity Estimator", excel: true, pdf: true},
                { id: 'status-activity-pipeline-Estimator-total', name: "Pipeline Activity Estimator - With Total", excel: true, pdf: true},
            ],
        };
    },

    created(){
        var offset = new Date().getTimezoneOffset();
        this.zone_time = offset.toString().includes('-');
        if (offset.toString().includes('-') == true){
            var minutes_format = offset.toString().substring(1);
            this.minutes = parseInt(minutes_format);
        }else{
            this.minutes = -offset;
        }
    },

    methods: {
        changeTime(newtime){
            var date_current = new Date();
            var changemintue = new Date(date_current.getFullYear()+'-'+(date_current.getMonth()+1)+'-'+date_current.getDay()+' '+ newtime);
            var add_mint = moment(changemintue).add(this.minutes, 'm').toDate()
            var time_exact = moment(add_mint).format('HH:mm');
            return time_exact
        },

        deleteReport(reportId){
            let payload = {
                'user_id': this.user.id,
                'team_id': this.user.current_team_id,
                'report_id': reportId
            }
            axios.post('settings/delete-schedule-report', payload)
                .then(response => {
                    if(response.data.status){
                        this.form.schedule_delete_message = response.data.message
                        this.form.schedule_delete_success = true
                        setTimeout(function(){
                            window.location.reload()
                        },2000 )
                    } else {
                        this.form.schedule_delete_message = response.data.message
                        this.form.schedule_delete_success = false
                    }

                }).catch(err=>{
                console.log('error', err)
            });
        },
        editScheduleReport(item){
            this.scheduleReportForm.id = item.id;
            this.scheduleReportForm.subject = item.subject;
            this.scheduleReportForm.delivery_frequency = item.delivery_frequency;
            this.scheduleReportForm.scheduled_time = this.changeTime(item.scheduled_time);
            this.scheduleReportForm.scheduled_day = !(item.delivery_frequency === "Daily") ? item.scheduled_day.toLocaleLowerCase() : '';
            this.scheduleReportForm.report_name = item.report_name;
            this.scheduleReportForm.report_format = item.report_format;
            this.scheduleReportForm.report_id = item.report_id;
            this.scheduleReportForm.report_name = item.report_name;
            this.scheduleReportForm.scheduled_day_disabled = (item.delivery_frequency === "Daily");
            this.scheduleReportForm.report_format_disabled = this.reports_exports.some(el => el.id === item.report_id);
            this.scheduleReportForm.recipients = item.recipients.split(',').map(value => ({email: value}))
            $("#scheduleReportEdit").modal("show");
        },
        addRecipient(newEmail) {
            let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
            if (newEmail.match(mailFormat)) {
                const tag = {
                    email: newEmail,
                };
                this.scheduleReportForm.recipients.push(tag);
            } else {
                this.fireErrorToast("You have entered an invalid email address!");
            }
        },
        frequencyChanged(event) {
            if(event.target.value === "Daily") {
                this.scheduleReportForm.scheduled_day_disabled = true
                this.scheduleReportForm.scheduled_day = ''
            }else {
                this.scheduleReportForm.scheduled_day_disabled = false
            }
        },

        scheduleReport() {
            this.scheduleReportHasError = false;
            this.validateField('subject', 'Subject');
            this.validateField('recipients', 'Recipients');
            this.validateField('delivery_frequency', 'Delivery Frequency');
            this.validateField('scheduled_time', 'Scheduled Time');
            this.validateField('report_format', 'Format');
            if(this.scheduleReportForm.delivery_frequency !== "Daily"){
                this.validateField('scheduled_day', 'Delivery Day');
            }
            if(this.scheduleReportHasError) {
                return false
            }
            if(this.scheduleReportForm.delivery_frequency === "Daily") {
                this.scheduleReportForm.scheduled_day = '';
            }

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            axios.post(route('api.schedule-report.update'), this.scheduleReportForm).then(response => {
                if (response.data.status) {
                    Toast.fire({
                        type: "success",
                        title: response.data.message
                    });
                    this.appendObject(response.data.scheduled_report);
                    this.scheduleReportForm.reset();
                    $("#scheduleReportEdit").modal("hide");

                } else {
                    Toast.fire({
                        type: "error",
                        title: response.data.message
                    });
                }
            }).catch((error) => {
                console.log('error', error);
            })
        },
        validateField(fieldName, fieldLabel) {
            if(fieldName === 'recipients') {
                if(this.scheduleReportForm[fieldName].length === 0) {
                    this.scheduleReportErrors[fieldName] = fieldLabel+' is required'
                    this.scheduleReportHasError = true
                }
            }else{
                if(!this.scheduleReportForm[fieldName].trim()) {
                    this.scheduleReportErrors[fieldName] = fieldLabel+' is required'
                    this.scheduleReportHasError = true
                }
            }

        },
        appendObject(data){
            let objIndex = this.reports.findIndex((obj => obj.id === data.id));
            this.reports[objIndex].subject = data.subject;
            this.reports[objIndex].delivery_frequency = data.delivery_frequency;
            this.reports[objIndex].scheduled_time = data.scheduled_time;
            this.reports[objIndex].scheduled_day = !(data.delivery_frequency === "Daily") ? data.scheduled_day ? data.scheduled_day.charAt(0).toUpperCase() + data.scheduled_day.slice(1) : '' : '';
            this.reports[objIndex].report_format = data.report_format;
            this.reports[objIndex].report_name = data.report_name;
        }
    }
};
</script>
